// Campus photo for /colleges/bowling-green-state-university: CC BY-SA 4.0, by Mbrickn, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_Hall_Facade.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/bowling-green-state-university/; credited under the photo.
const photo = {
    "slug": "bowling-green-state-university",
    "alt": "University Hall across a sunny lawn and bare trees at Bowling Green State University in Bowling Green, Ohio",
    "src": "/colleges/bowling-green-state-university/campus-1600.webp",
    "srcSmall": "/colleges/bowling-green-state-university/campus-800.webp",
    "srcMid": "/colleges/bowling-green-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/bowling-green-state-university/og.jpg",
    "title": "University Hall Facade",
    "author": "Mbrickn",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_Hall_Facade.jpg",
    "read": "2026-10-01"
};

export default photo;
